import Axios, { AxiosInstance } from "axios";
import router from "@/router";
import store from "@/store";
import Vue from "vue";
import authHeader from "@/common/qAuthHeader";

export interface ApiResponse {
  meta: any;
  data: any;
}

class api {
  public http: any;
  public loader: any;
  getAuthenticateStatus(): string | null {
    return store.state.Auth.authenticate_status || "";
  }
  getTokenExpiredTime(): string | null {
    return store.state.Auth.expired_at || "";
  }

  getUserType(): string | null {
    return store.state.Auth.user_type || "";
  }

  getHttp(): AxiosInstance {
    return this.http;
  }
  showLoading(response) {
    if (
      response.config &&
      response.config.data &&
      response.config.data instanceof FormData
    ) {
      this.loader && this.loader.hide();
    } else if (response.config && response.config.data) {
      const configData = JSON.parse(response.config.data);
      this.loader && configData.notLoading === undefined && this.loader.hide();
    } else {
      this.loader && this.loader.hide();
    }
  }
  setup(): void {
    // set basic url or toket
    const config = {
      headers: {
        "Content-Type": "application/json",

        // disable IE11 GET cache
        // @see https://stackoverflow.com/questions/37755782/prevent-ie11-caching-get-call-in-angular-2
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
      baseURL: process.env.VUE_APP_API_URL,
    };
    this.http = Axios.create(config);
    this.http.interceptors.request.use(
      (config: any) => {
        // console.log(this.loader);

        const token = authHeader();
        this.loader && this.loader.hide();
        if (!(config.data && config.data.notLoading)) {
          this.loader && this.loader.hide();
          this.loader = Vue.$loading.show({});
        }
        if (token.Authorization) {
          config.headers = { ...config.headers, ...token };
        }

        const userType = this.getUserType();
        if (userType) {
          config.headers = { ...config.headers, ...{ "User-Type": userType } };
        }
        return config;
      },
      (error: any) => {
        this.showLoading(error);
        // Do something with request error
        return Promise.reject(error);
      }
    );
    this.http.interceptors.response.use(
      (response: any) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        this.showLoading(response);
        return response;
      },
      (error: any) => {
        this.showLoading(error);
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (
          (error.response.status === 401 &&
          router.currentRoute.name !== "login")
          || error.response.status === 503
        ) {
          // AuthModule.logout();
          router.push({ name: "login" });
          return Promise.resolve(error.response);
        } else if (error.response.status === 403) {
          router.push({ name: "error" });
          return Promise.reject(error.response);
        } else {
          return Promise.resolve(error.response);
        }
      }
    );
  }
}

export default api;
